import * as React from 'react';
import { Tabs, Tab, TabsState } from '../Tabs';
import OngoingCareer from "./OngoingCareer";
import { RouteComponentProps } from 'react-router';
import ScientificProductivity from "./ScientificProductivity";
import R01Attainment from "./R01Attainment";
import FundingSequence from "./FundingSequence";
import TeamScience from "./TeamScience";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ApplicationState } from '../../../reducers/Index';
import { UserState } from "../../../interface/MyInterfaces";
import { CTSAReportState } from '../../../interface/CTSAReportInterface';
import {
    hydrateComparisonGroup,
    loadAvailableGroup,
    loadAwardTotal,
    changeComparisonGroup,
    loadCareerData,
    loadAwardPathway,
    loadKL2ModalPath,
    loadAwardData, loadBibs,
    loadJournals,
    loadMeshTerms,
    loadPatentNumber,
    loadPatentSector,
    loadTeam,
    loadTeamGender,
    shareCTSAReport,
    loadMethodGroup,
    loadMethodMatch
} from '../../../actions/CTSAReportActions';
import Methodology from './Methodology';

interface Props {
    UserState?: UserState;
    CTSAReportState?: CTSAReportState;
    changeComparisonGroup?();
    hydrateComparisonGroup?(availableGroup);
    loadAvailableGroup?(displayId);
    loadAwardTotal?(displayId);
    loadCareerData?(displayId);
    loadPatentNumber?(displayId);
    loadPatentSector?(displayId);
    loadBibs?(displayId);
    loadJournals?(displayId);
    loadMeshTerms?(displayId, comparisonGroup, rank_difference?: number);
    loadAwardData?(displayId, outcome_award);
    loadAwardPathway?(displayId);
    loadKL2ModalPath?(displayId);
    loadTeam?(displayId);
    loadTeamGender?(displayId);
    loadMethodGroup?(displayId);
    loadMethodMatch?(displayId);
    handleTabClickFromParent?();
    shareCTSAReport?(link_id, p1, p2);
}



class CTSAReport extends React.Component<Props & RouteComponentProps<{}>, TabsState> {
    componentDidMount() {
        const reportType = this.props.match.path;
        const { loadAvailableGroup, loadAwardTotal, loadCareerData, loadPatentNumber, loadPatentSector, loadBibs, loadJournals, loadAwardData, loadAwardPathway, loadKL2ModalPath, loadTeam, loadTeamGender, loadMethodGroup, loadMethodMatch } = this.props;
        const displayId = /agg/g.test(reportType) ? "-1" : this.props.UserState.report_display_id;
      
        if (this.props.match.params !== undefined &&
            this.props.match.params["link_id"] !== undefined &&
            this.props.match.params["p1"] !== undefined &&
            this.props.match.params["p2"] !== undefined) {
          

            this.props.shareCTSAReport(this.props.match.params["link_id"],
                this.props.match.params["p1"] ,
                this.props.match.params["p2"] );
        } else {
            loadAwardTotal(displayId);
            loadAvailableGroup(displayId);
            loadCareerData(displayId);
            loadPatentNumber(displayId);
            loadPatentSector(displayId);
            loadBibs(displayId);
            loadJournals(displayId);
            loadAwardData(displayId, 'R01');
            loadAwardPathway(displayId);
            loadKL2ModalPath(displayId);
            loadTeam(displayId);
            loadTeamGender(displayId);
            loadMethodGroup(displayId);
            loadMethodMatch(displayId);
        }

    }
    componentDidUpdate(prevProps) {
        const reportType = "ctsa-report";//this.props.match.path;

        const displayId = /agg/g.test(reportType) ? "-1" : this.props.UserState.report_display_id;


        if (prevProps.CTSAReportState.availableGroup !== this.props.CTSAReportState.availableGroup) {
            this.props.hydrateComparisonGroup(this.props.CTSAReportState.availableGroup);
        }

        if (prevProps.CTSAReportState.comparisonGroup !== this.props.CTSAReportState.comparisonGroup) {
            this.props.loadMeshTerms(displayId, this.props.CTSAReportState.comparisonGroup);
        }
    }

    render() {
        const { report_display_id, UniversityListCTSAReport } = this.props.UserState;
        const reportType = "ctsa-report";//this.props.match.path;

        //const reportType = this.props.match.path;
        const displayId = /agg/g.test(reportType) ? "-1" : report_display_id;


        if (this.props.CTSAReportState) {
            const { awardTotal, careerData, comparisonGroup, availableGroup, patentNumber, patentSector, bibs, journals, mesh, awardData, awardPathway, kl2ModalPathway, team, teamGender, methodologyGroup, methodologyMatch } = this.props.CTSAReportState;
            return (

                <Tabs>
                    <Tab
                        handleTabClickFromParent={this.props.handleTabClickFromParent}
                        iconClassName={'fa fa-headphones'}
                        linkClassName={'custom-link'}
                        arialabel="Opening Careers in Research tab"
                        tabName="Careers in Research">
                        <OngoingCareer
                            awardTotal={awardTotal}
                            displayId={displayId}
                            CTSASchoolList={UniversityListCTSAReport}
                            comparisonGroup={comparisonGroup}
                            careerData={careerData}
                            availableGroup={availableGroup}
                            changeComparisonGroup={this.props.changeComparisonGroup}
                        />
                    </Tab>

                    <Tab
                        handleTabClickFromParent={this.props.handleTabClickFromParent}
                        iconClassName={'fa fa-headphones'}
                        linkClassName={'custom-link'}
                        arialabel="Opening Scientific Productivity tab"
                        tabName="Scientific Productivity">
                        <ScientificProductivity
                            awardTotal={awardTotal}
                            displayId={displayId}
                            CTSASchoolList={UniversityListCTSAReport}
                            availableGroup={availableGroup}
                            comparisonGroup={comparisonGroup}
                            changeComparisonGroup={this.props.changeComparisonGroup}
                            patentSector={patentSector}
                            patentNumber={patentNumber}
                            bibs={bibs}
                            journals={journals}
                            mesh={mesh}
                        />

                    </Tab>

                    <Tab
                        handleTabClickFromParent={this.props.handleTabClickFromParent}
                        iconClassName={'fa fa-headphones'}
                        linkClassName={'custom-link'}
                        arialabel="Opening R01 Attainment tab"
                        tabName="R01 Attainment">
                        <R01Attainment
                            awardTotal={awardTotal}
                            displayId={displayId}
                            CTSASchoolList={UniversityListCTSAReport}
                            availableGroup={availableGroup}
                            comparisonGroup={comparisonGroup}
                            changeComparisonGroup={this.props.changeComparisonGroup}
                            awardData={awardData}
                        />

                    </Tab>

                    <Tab
                        handleTabClickFromParent={this.props.handleTabClickFromParent}
                        iconClassName={'fa fa-headphones'}
                        linkClassName={'custom-link'}
                        arialabel="Opening Funding Sequence tab"
                        tabName="Funding Sequence">
                        <FundingSequence
                            awardTotal={awardTotal}
                            displayId={displayId}
                            CTSASchoolList={UniversityListCTSAReport}
                            availableGroup={availableGroup}
                            comparisonGroup={comparisonGroup}
                            changeComparisonGroup={this.props.changeComparisonGroup}
                            awardPathway={awardPathway}
                            kl2ModalPathway={kl2ModalPathway}
                        />

                    </Tab>

                    <Tab
                        handleTabClickFromParent={this.props.handleTabClickFromParent}
                        iconClassName={'fa fa-headphones'}
                        linkClassName={'custom-link'}
                        arialabel="Opening Team Science tab"
                        tabName="Team Science">
                        <TeamScience
                            awardTotal={awardTotal}
                            displayId={displayId}
                            CTSASchoolList={UniversityListCTSAReport}
                            availableGroup={availableGroup}
                            comparisonGroup={comparisonGroup}
                            changeComparisonGroup={this.props.changeComparisonGroup}
                            team={team}
                            teamGender={teamGender}
                        />
                    </Tab>

                    <Tab
                        handleTabClickFromParent={this.props.handleTabClickFromParent}
                        iconClassName={'fa fa-headphones'}
                        linkClassName={'custom-link'}
                        arialabel="Opening Methodology tab"
                        tabName="Methodology">
                        <Methodology
                            methodologyGroup={methodologyGroup}
                            methodologyMatch={methodologyMatch}
                            awardTotal={awardTotal}

                        />
                    </Tab>

                </Tabs>

            );


        } else {
            return <i className="fa fa-spinner"></i>;
        }



    }
}
const mapStateToProps = (state: ApplicationState) => ({
    UserState: state.userProperties,
    CTSAReportState: state.CTSAReportProperties
});


const mapDispatchToProps = {
    changeComparisonGroup,
    hydrateComparisonGroup,
    loadAvailableGroup,
    loadAwardTotal,
    loadCareerData,
    loadPatentNumber,
    loadPatentSector,
    loadBibs,
    loadJournals,
    loadMeshTerms,
    loadAwardPathway,
    loadKL2ModalPath,
    loadAwardData,
    loadTeam,
    loadTeamGender,
    loadMethodGroup,
    loadMethodMatch,
    shareCTSAReport
}


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CTSAReport);

